import css from 'styled-jsx/css';

const style = css`
  .timeline-wrapper {
    margin: 0 24px 24px 8px;
  }
  .fuel-transaction-timeline-empty {
    display: flex;
    justify-content: center;
    padding: 24px;
  }
`;

export default style;
